import { useI18n } from 'vue-i18n';
import type { SearchParameters } from './types';

import kk from './config/locales/kk.json';
import ru from './config/locales/ru.json';
import en from './config/locales/en.json';

export const usePassengersText = () => {
  const { t } = useI18n({ messages: { ru, kk, en } });

  const getPassengersText = (searchParameters: SearchParameters) => {
    const { adults, children, infants, youth } = searchParameters;

    const hasPax = (amount: number) => amount > 0;

    if (youth > 0) {
      return `${t('youthShort', youth)}`;
    }

    const parts = [t('adultShort', adults)];

    if (hasPax(children)) {
      parts.push(t('childShort', children));
    }

    if (hasPax(infants)) {
      parts.push(t('infantShort', infants));
    }

    return parts.join(', ');
  };

  return {
    getPassengersText,
  };
};
